var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.pinOrderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "拼团名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "拼团名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keyword", $$v)
                                },
                                expression: "listPram.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.dataRenage,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dataRenage", $$v)
                              },
                              expression: "listPram.dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "uname", label: "团长", "min-width": "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "combinationName",
                  label: "拼团名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "statusStr", label: "状态", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "startTimeStr",
                  label: "开始时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "endTimeStr",
                  label: "结束时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "people", label: "几人团", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "countPeople",
                  label: "几人参加",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "对应小程序",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "160",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:store:pink:detailList"],
                                expression: "['admin:store:pink:detailList']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:store:pink:getShareCode"],
                                    expression:
                                      "['admin:store:pink:getShareCode']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.previewQrImg(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("分享码")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:store:pink:end"],
                                    expression: "['admin:store:pink:end']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.endPintuanOrder(scope.row, "end")
                                  },
                                },
                              },
                              [_vm._v("设为完成")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:store:pink:updateStatus"],
                                    expression:
                                      "['admin:store:pink:updateStatus']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.endPintuanOrder(
                                      scope.row,
                                      "cancel"
                                    )
                                  },
                                },
                              },
                              [_vm._v("取消跟团")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderDetail", {
        ref: "OrderDetailRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }